"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetTextContents = void 0;
const core = __importStar(require("../../core"));
exports.WidgetTextContents = core.serialization.object({
    mainLabel: core.serialization.property("main_label", core.serialization.string().optional()),
    startCall: core.serialization.property("start_call", core.serialization.string().optional()),
    startChat: core.serialization.property("start_chat", core.serialization.string().optional()),
    newCall: core.serialization.property("new_call", core.serialization.string().optional()),
    endCall: core.serialization.property("end_call", core.serialization.string().optional()),
    muteMicrophone: core.serialization.property("mute_microphone", core.serialization.string().optional()),
    changeLanguage: core.serialization.property("change_language", core.serialization.string().optional()),
    collapse: core.serialization.string().optional(),
    expand: core.serialization.string().optional(),
    copied: core.serialization.string().optional(),
    acceptTerms: core.serialization.property("accept_terms", core.serialization.string().optional()),
    dismissTerms: core.serialization.property("dismiss_terms", core.serialization.string().optional()),
    listeningStatus: core.serialization.property("listening_status", core.serialization.string().optional()),
    speakingStatus: core.serialization.property("speaking_status", core.serialization.string().optional()),
    connectingStatus: core.serialization.property("connecting_status", core.serialization.string().optional()),
    chattingStatus: core.serialization.property("chatting_status", core.serialization.string().optional()),
    inputLabel: core.serialization.property("input_label", core.serialization.string().optional()),
    inputPlaceholder: core.serialization.property("input_placeholder", core.serialization.string().optional()),
    inputPlaceholderTextOnly: core.serialization.property("input_placeholder_text_only", core.serialization.string().optional()),
    inputPlaceholderNewConversation: core.serialization.property("input_placeholder_new_conversation", core.serialization.string().optional()),
    userEndedConversation: core.serialization.property("user_ended_conversation", core.serialization.string().optional()),
    agentEndedConversation: core.serialization.property("agent_ended_conversation", core.serialization.string().optional()),
    conversationId: core.serialization.property("conversation_id", core.serialization.string().optional()),
    errorOccurred: core.serialization.property("error_occurred", core.serialization.string().optional()),
    copyId: core.serialization.property("copy_id", core.serialization.string().optional()),
});
